import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  const features = [
    'Large inventory readiness',
    'Wide range under one roof',
    'Fast order fulfillment',
    'Consistent demand and repeat business',
    'Professional and transparent dealings'
  ];

  return (
    <div className="about-us-page">
      <div className="about-hero">
        <h1 className="about-title">About GSPS Trading Corporation</h1>
      </div>

      <div className="about-container">
        <div className="about-content">
          <div className="about-section">
            <p className="about-intro">
              We are a trusted distributor of aftermarket spare parts for heavy commercial vehicles. 
              Our business is driven by quality, strong stock holding, and operational efficiency.
            </p>
            <p className="about-intro">
              Our wide product range and faster supply capability allow our customers to source most 
              requirements from one place, helping reduce downtime and improve efficiency.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-heading">What Defines Us</h2>
            <div className="features-list">
              {features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-bullet"></div>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;

